// Libraries
import React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl';
// Our stuff
import './Layout.css';

const Layout = ({children}) => {    
    return <div className='driver_validation_complaints__layout'>
        {children}
    </div>
}

export default Layout;